import { formatDate } from '@vueuse/core'

/**
 * Formats a target publish date string into a specified date format.
 *
 * @param targetPublishDate - The date string to format. Accepts ISO strings with or without a trailing 'Z'.
 * @param dateFormat - The desired output format (default: 'YYYY/MM').
 * @returns The formatted date string.
 * @category Utils
 */

export const formatTargetPublishDate = (
  targetPublishDate: string,
  dateFormat: string = 'YYYY/MM'
) =>
  formatDate(
    new Date(
      targetPublishDate.endsWith('Z')
        ? targetPublishDate
        : targetPublishDate.replace(/-/g, '/')
    ),
    dateFormat
  )
